import { useState, useRef, useCallback } from 'react';
import api from '../lib/api';

export function usePaymentExecution(searchParams, refreshUser) {
  const [status, setStatus] = useState('loading');
  const [paymentInfo, setPaymentInfo] = useState(null);
  const executedRef = useRef(false);

  const execute = useCallback(async () => {
    if (executedRef.current) return;

    const paymentId = searchParams.get('paymentId');
    const payerId = searchParams.get('PayerID');
    const type = searchParams.get('type');

    if (!paymentId || !payerId) {
      setStatus('error');
      return;
    }

    executedRef.current = true;

    try {
      const response = await api.post('/payment/execute', {
        payment_id: paymentId,
        payer_id: payerId
      });
      const paymentType = type || response.data.type;
      setPaymentInfo({ type: paymentType, payment_status: response.data.status });
      if (response.data.status === 'paid') {
        setStatus('success');
        if (paymentType === 'premium') {
          await refreshUser();
        }
      } else {
        setStatus('pending');
      }
    } catch {
      setStatus('error');
    }
  }, [searchParams, refreshUser]);

  return { status, paymentInfo, execute };
}
